import type { LevelUpMessage } from "@mucki/shared";

export interface LevelUpNotice {
  show(message: LevelUpMessage): void;
  dispose(): void;
}

const VISIBLE_MS = 3000;

export function createLevelUpNotice(parent: HTMLElement = document.body): LevelUpNotice {
  const banner = document.createElement("div");
  banner.className = "level-up-notice";

  const title = document.createElement("div");

  const detail = document.createElement("div");
  detail.className = "level-up-notice-detail";

  banner.append(title, detail);
  parent.appendChild(banner);

  let timer = 0;

  return {
    show: (message) => {
      title.textContent = `Level ${message.level}`;
      detail.textContent = `${message.maxHealth} health · ${message.maxEnergy} energy · ${message.baseDamage} damage`;
      banner.classList.add("is-visible");
      window.clearTimeout(timer);
      timer = window.setTimeout(() => banner.classList.remove("is-visible"), VISIBLE_MS);
    },
    dispose: () => {
      window.clearTimeout(timer);
      banner.remove();
    },
  };
}
